"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KebabFormat = KebabFormat;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _IconButton = _interopRequireDefault(require("@eig-builder/core-ui/IconButton"));

var _Menu = _interopRequireDefault(require("@eig-builder/core-ui/Menu"));

var _kebabMenuItem = require("./kebab-menu-item");

function KebabFormat(props) {
  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var handleKebabClick = function handleKebabClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleKebabClose = function handleKebabClose() {
    setAnchorEl(null);
  };

  var kebabOpen = Boolean(anchorEl);
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "More",
    "aria-owns": kebabOpen ? 'long-menu' : undefined,
    "aria-haspopup": "true",
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: "kebab-icon",
    dataElementId: "kebab-menu-table-row-item-more-".concat(props.value),
    onClick: handleKebabClick
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "more_vert"
  })), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    id: "long-menu",
    anchorEl: anchorEl,
    open: kebabOpen,
    onClose: handleKebabClose,
    dataElementId: props.dataElementId,
    dataElementLabel: props.dataElementLabel,
    dataElementLocation: props.dataElementLocation
  }, (0, _kebabMenuItem.KebabMenuItem)(props.kebabItems, props.record.id, handleKebabClose)));
}

KebabFormat.propTypes = {
  kebabItems: _propTypes["default"].array,
  record: _propTypes["default"].object,
  value: _propTypes["default"].string,
  dataElementLocation: _propTypes["default"].oneOf(_taggingHelper.DataElementLocationsArray).isRequired,
  dataElementLabel: _propTypes["default"].string.isRequired,
  dataElementId: _propTypes["default"].string.isRequired
};